import { Button, TextField, Box, Typography, Stack, IconButton, Accordion, AccordionSummary, AccordionDetails, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const inputProps = { size: "small", sx: { height: 40 } };

export default function HREducationDetails({ formData, errors, visibleEduCount, addEducation, removeEducation, handleEducationChange }) {

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    // ✅ VALIDATION HELPER FUNCTIONS
    const isPassingYearValid = (year) => {
        if (!year || String(year).length === 0) return true; // Empty is OK
        return String(year).length === 4;
    };

    const isPercentageValid = (percentage) => {
        if (!percentage || String(percentage).length === 0) return true; // Empty is OK
        return Number(percentage) >= 0;
    };

    return (
        <Stack spacing={3}>
            <Typography variant="h6" color="primary"> Education Details </Typography>

            {/* SHOW ONLY ACCORDING TO SLICE */}
            {formData.educationDetails
                .slice(0, visibleEduCount)
                .map((edu, index) => (
                    <Accordion key={index} defaultExpanded={index === 0}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography fontWeight={"bold"}> Education {index + 1} </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Stack spacing={2}>
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <TextField required label="Qualification" {...inputProps} sx={{ flex: 1 }} type="text" value={edu.qualification} onChange={(e) => handleEducationChange(index, "qualification", e.target.value)} size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} error={errors[`educationDetails_${index}_qualification`]} />
                                    <TextField required label="College Name" {...inputProps} sx={{ flex: 1 }} type="text" value={edu.collegeName} onChange={(e) => handleEducationChange(index, "collegeName", e.target.value)} size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} error={errors[`educationDetails_${index}_collegeName`]} />
                                </Box>

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <TextField required label="Passing Year" {...inputProps} sx={{ flex: 1 }} type="text" value={edu.passingYear} onChange={(e) => { const value = e.target.value.replace(/\D/g, "").slice(0, 4); handleEducationChange(index, "passingYear", value); }} InputLabelProps={{ sx: requiredAsteriskStyle }} error={errors[`educationDetails_${index}_passingYear`] || !isPassingYearValid(edu.passingYear)} helperText={!isPassingYearValid(edu.passingYear) ? "Passing year must be exactly 4 digits" : ""} />
                                    <TextField required label="Percentage / CGPA" {...inputProps} sx={{ flex: 1 }} type="number" value={edu.percentage} onChange={(e) => { const value = e.target.value; if (value === "" || Number(value) >= 0) { handleEducationChange(index, "percentage", value); } }} InputLabelProps={{ sx: requiredAsteriskStyle }} error={errors[`educationDetails_${index}_percentage`] || !isPercentageValid(edu.percentage)} helperText={!isPercentageValid(edu.percentage) ? "Percentage cannot be negative" : ""} inputProps={{ min: 0 }} />
                                </Box>

                                {/* REMOVE BUTTON */}
                                {(visibleEduCount > 1 && index > 0) && (
                                    <Box textAlign="right">
                                        <IconButton color="error" onClick={() => removeEducation(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                ))}

            {/* ADD MORE BUTTON */}
            <Box>
                <Button variant="outlined" startIcon={<AddIcon />} onClick={addEducation} sx={{ width: 'auto' }} > Add More Education </Button>
            </Box>
        </Stack>
    );
}